/* eslint-env browser, jquery */
/* globals Backbone */

'use strict';

const GoodsWarrantyHelpers = require('../../../goods_warranty/common/helpers');

const GoodsWarrantyModalView = require('./goods_warranty_modal');

const GoodsWarrantyView = Backbone.View.extend({
  el: '.goods-warranty',
  events: {
    'change .goods-warranty-option': 'updateModelSelectedState',
    'click .more-details': 'showGoodsWarrantyModal',
  },

  initialize({ goodsWarranty }) {
    ({
      dealOptionWarranties: this.dealOptionWarranties,
      showMultiOptionBreakout: this.showMultiOptionBreakout,
    } = goodsWarranty);
    this.listenTo(
      this.model,
      'change:isSelected',
      this.updateWarrantyCheckboxState
    );
    this.initializeWarrantyOption();
    this.initializeWarrantyModal();

    if (this.showMultiOptionBreakout) {
      this.initializeMultiOptionBreakoutPane();
    }

    window.DealEventPipe.on('goodsOptionUpdate', (data = {}) => {
      this.optionInfo = data;
      this.model.set({
        buyUrl: data.buyUrl,
        bundleCheckoutUrl: this.getBundleCheckoutUrl(),
      });
      this.updateWarrantyOption();
      this.updateWarrantyModal();
      this.updateBuyButtonUrl();
    });

    if (window.BuyButtonEventPipe) {
      window.BuyButtonEventPipe.on('buy_button_clicked', () => {
        return {
          goodsWarrantyUrl:
            !!this.model.get('isSelected') &&
            this.model.get('bundleCheckoutUrl'),
        };
      });
    }
  },

  initializeMultiOptionBreakoutPane() {
    const $multiBreakoutOptions = $('#options-pane .option a');

    if (!$multiBreakoutOptions || !$multiBreakoutOptions.length) {
      return;
    }

    $multiBreakoutOptions.click(e => {
      if (!this.model.get('isSelected')) {
        return;
      }

      const $option = $(e.currentTarget);
      const { deal, uuid } = $option.data();
      this.optionInfo = {
        dealUuid: deal,
        uuid,
      };
      const bundleCheckoutUrl = this.getBundleCheckoutUrl();

      if (bundleCheckoutUrl && bundleCheckoutUrl.length) {
        $option.attr('href', bundleCheckoutUrl);
      }
    });
  },

  initializeWarrantyOption() {
    this.$buyButton = $('#buy, a.buy-button');
    this.$goodsWarrantyOption = $('.goods-warranty-option');
    this.$warrantyMessage = this.$el.find(
      '.warranty-option-message .warranty-message-content'
    );

    if (!this.$warrantyMessage.length) {
      this.$warrantyMessage = this.$el.find('.warranty-option-message');
    }

    this.model.set('isSelected', false);
  },

  initializeWarrantyModal() {
    this.$warrantyModal = $('#goods-warranty-modal');
    this.$warrantyModalTitle = this.$warrantyModal.find(
      '.warranty-option-message'
    );
    this.$warrantyModalServiceMessage = this.$warrantyModal.find(
      '.bundle-service-messages'
    );
    this.modalView = new GoodsWarrantyModalView({
      model: this.model,
    });
  },

  getBundleCheckoutUrl() {
    const { dealUuid, uuid } = this.optionInfo;

    const warrantyOption = GoodsWarrantyHelpers.getFirstWarrantyOption(
      uuid,
      this.dealOptionWarranties
    );

    if (!warrantyOption) {
      return null;
    }

    return GoodsWarrantyHelpers.generateBundleCheckoutUrl(
      dealUuid,
      uuid,
      warrantyOption
    );
  },

  showGoodsWarrantyModal() {
    if (!this.$body) {
      this.$body = $('body');
    }

    if (!this.$htmlbody) {
      this.$htmlbody = $('html, body');
    }

    if (!this.$mainTouchPane) {
      this.$mainTouchPane = $('#global-container');
    }

    this.modalView.scrollOffset = this.$body.scrollTop();
    this.$mainTouchPane.hide();
    this.$warrantyModal.show();
    this.$htmlbody.animate(
      {
        scrollTop: 0,
      },
      'slow'
    );
    this.$body.animate(
      {
        scrollTop: 0,
      },
      'slow'
    );
  },

  updateModelSelectedState(e) {
    this.model.set('isSelected', $(e.currentTarget).prop('checked'));
  },

  updateBuyButtonUrl() {
    const buyButtonUrl = this.model.get('isSelected')
      ? this.model.get('bundleCheckoutUrl')
      : this.model.get('buyUrl');

    if (buyButtonUrl && buyButtonUrl.length) {
      this.$buyButton.attr('href', buyButtonUrl);
    }
  },

  updateWarrantyCheckboxState() {
    if (
      this.$goodsWarrantyOption.prop('checked') !== this.model.get('isSelected')
    ) {
      this.$goodsWarrantyOption
        .prop('checked', this.model.get('isSelected'))
        .change();
    }

    if (window.BuyButtonEventPipe) {
      window.BuyButtonEventPipe.trigger('toggleAddToCartButton', {
        showAddToCartButton: !(
          this.$goodsWarrantyOption.prop('checked') === true
        ),
      });
    }

    if (
      this.showMultiOptionBreakout ||
      (this.optionInfo && this.optionInfo.variationsSelected)
    ) {
      this.updateBuyButtonUrl();
    }
  },

  updateWarrantyModal() {
    this.$warrantyModal
      .removeClass('replacement-plan-selected repair-plan-selected')
      .addClass(this.warrantyOption && this.warrantyOption.selectedCssClass);

    this.serviceMessages =
      this.warrantyOption && this.warrantyOption.warrantyPitchHtml;

    this.$warrantyModalTitle.html(this.warrantyMessage);
    this.$warrantyModalServiceMessage.html(this.serviceMessages);
  },

  updateWarrantyOption() {
    this.warrantyOption = GoodsWarrantyHelpers.getFirstWarrantyOption(
      this.optionInfo && this.optionInfo.uuid,
      this.dealOptionWarranties
    );

    this.warrantyMessage =
      this.warrantyOption && this.warrantyOption.warrantyMessage;

    this.$warrantyMessage.html(this.warrantyMessage);
    this.$el.toggleClass('close', !this.warrantyMessage);
  },
});

module.exports = GoodsWarrantyView;
